// LoginForm.tsx
import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAuth } from "../../../hooks/useAuth";

// Типы для состояния компонента
interface LoginState {
  emailOrUsername: string;
  // accountName: string;
  password: string;
}

interface LoginFormProps {
  onSuccess?: () => void;
}

// Компонент формы
const LoginForm: React.FC<LoginFormProps> = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState<LoginState>({
    emailOrUsername: "",
    // accountName: "",
    password: "",
  });

  const auth = useAuth();

  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const handleClickShowPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    setShowPassword((show) => !show);
    event.currentTarget.blur();
  }

  // Предотвращаем дефолтное поведение при нажатии на иконку
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  // Обработчик изменения полей
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // Обработчик отправки формы
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setErrorMessage("");
    
    try {
      const res = await auth.login(
        // method: "password",
        formData.emailOrUsername,
        formData.password,
      );
      console.log('res',res);
      if (res.user.is_email_confirmed) {
        onSuccess?.();
      } else {
        setErrorMessage(t("LoginForm.registrationNotCompleted"));
      }
    } catch (error: any) {
      setErrorMessage(error.message || t("LoginForm.UnknownError"));
    }  
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2, // Отступ между элементами (1 = 8px)
        maxWidth: 400,
        mx: "auto", // Центрирование формы
        p: 3,
        border: "1px solid #ccc",
        borderRadius: "8px",
      }}
    >
      <Typography variant="h4" component="h1" align="center">
        {t('LoginForm.Login')}
      </Typography>
      
      {errorMessage && (
        <Typography color="error" align="center" sx={{ mt: -1, mb: 1, fontWeight: "bold" }}>
          {errorMessage}
        </Typography>
      )}      
      
      <FormControl fullWidth>
        <TextField
          label={t('LoginForm.Email')}
          name="emailOrUsername"
          type="text"
          value={formData.emailOrUsername}
          onChange={handleInputChange}
          required
        />
      </FormControl>

      <FormControl fullWidth>
        <TextField
          label={t('LoginForm.Password')}
          name="password"
          // Тип поля меняется в зависимости от showPassword
          type={showPassword ? "text" : "password"}
          value={formData.password}
          onChange={handleInputChange}
          required
          // Добавляем иконку
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </FormControl>

      <Button type="submit" variant="contained">
        {/* Sign up */}
        {t('LoginForm.Login')}
      </Button>
    </Box>
  );
};

export default LoginForm;